import { ReportFilterOperationType, ReportSortDirectionType } from 'peekdata-datagateway-api-sdk';

const apiUrl = 'https://demo.peekdata.io:8443/datagateway/rest/v1';
const request = {
  scopeName: 'Mortgage-Lending',
  dataModelName: 'Servicing-PostgreSQL',
  dimensions: [
    'cityname',
    'currency',
  ],
  metrics: [
    'loanamount',
    'propertyprice',
  ],
  filters: {
    dateRanges: [{
      from: '2015-01-01',
      to: '2017-12-31',
      key: 'closingdate',
    }],
    singleKeys: [{
      key: 'countryname',
      operation: ReportFilterOperationType.EQUALS,
      values: ['Poland'],
    }],
  },
  sortings: {
    dimensions: [{
      key: 'cityname',
      direction: ReportSortDirectionType.ASC,
    }],
    metrics: [{
      key: 'propertyprice',
      direction: ReportSortDirectionType.ASC,
    }],
  },
  options: {
    rows: {
      limitRowsTo: '100',
    },
  },
};

export const dataapi = {
  apiUrl,
  request,
  colors: ['#d71c4e', '#70001E', '#AE9B94', '#392f32', '#7C6D67', '#61001A', '#ED6E90', '#96022A'],
  curlRequest: `
curl --location --request POST '${apiUrl}/data/getoptimized' \\
  --header 'Content-Type: application/json' \\
  --data-raw '${JSON.stringify(request, null, '  ')}'
`,
};
